function formatTime(timestamp) {
  if (timestamp == null || Number.isNaN(Number(timestamp))) return '';
  const n = Number(timestamp);
  const ms = n < 1e12 ? n * 1000 : n;
  return new Date(ms).toLocaleString();
}

async function fetchMetal(symbol) {
  const response = await fetch(`https://www.goldapi.io/api/${symbol}/USD`, {
    headers: {
      "x-access-token": "goldapi-1kvaizsmm1mnan2-io"
    }
  });

  if (!response.ok) throw new Error("Network error");

  return await response.json();
}

async function loadAllMetals() {
  try {
    const [gold, silver, platinum] = await Promise.all([
      fetchMetal("XAU"),
      fetchMetal("XAG"),
      fetchMetal("XPT")
    ]);

    // GOLD
    document.querySelector(".gold-price").textContent =
      "$" + Number(gold.price).toLocaleString();

    document.querySelector(".gold-change").textContent =
      Number(gold.chp).toFixed(2) + "%";

    // SILVER
    document.querySelector(".silver-price").textContent =
      "$" + Number(silver.price).toLocaleString();

    document.querySelector(".silver-change").textContent =
      Number(silver.chp).toFixed(2) + "%";

    // PLATINUM
    document.querySelector(".platinum-price").textContent =
      "$" + Number(platinum.price).toLocaleString();

    document.querySelector(".platinum-change").textContent =
      Number(platinum.chp).toFixed(2) + "%";

    // ✅ UPDATE TIME DYNAMICALLY
   // const now = new Date();
    const updatedTime = formatTime(gold.timestamp);
    document.querySelector(".metal-rates__updated").textContent =
      "Updated: " + updatedTime;

  } catch (err) {
    const el = document.querySelector(".metal-rates__updated");
    if (el && !el.textContent.trim()) {
      el.textContent = "Last update failed";
    }
  }
}

// First load
loadAllMetals();

// Refresh every 2 hours
setInterval(loadAllMetals, 7200000);